import { type ReactNode, type ElementType } from "react";
import styles from "./DashboardCard.module.css";
import { type IconColor } from "./IconColors";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import Card from "./Card";
import FeaturedIcon from "./FeaturedIcon";
import { Button } from "@base-ui/react/button";
import Text from "./Text.tsx";

interface DashboardCardProps {
  title: string;
  value: ReactNode;
  valueSuffix?: ReactNode;
  subtitle?: ReactNode;
  icon: ElementType;
  iconColor?: IconColor;
  onClick?: () => void;
  className?: string;
}

export default function DashboardCard({
  title,
  value,
  valueSuffix,
  subtitle,
  icon: Icon,
  iconColor = "orange",
  onClick,
  className,
}: DashboardCardProps) {
  return (
    <Card
      as={onClick ? Button : undefined}
      onClick={onClick}
      className={classnames(styles.card, className)}
      padding="md"
    >
      <div className={styles.header}>
        <Text as="span" weight="bold">
          {title}
        </Text>
        <FeaturedIcon icon={Icon} size="sm" color={iconColor} />
      </div>
      <div className={styles.body}>
        <Text as="span" variant="mega" weight="bold">
          {value}
          {valueSuffix && (
            <Text as="span" variant="deca">
              {valueSuffix}
            </Text>
          )}
        </Text>
        <Text as="span" variant="deci">
          {subtitle}
        </Text>
      </div>
    </Card>
  );
}
